export default __webpack_public_path__ + "static/media/Mobile login-pana.754ae0ad.svg";